import React from "react";
import { BingoTileType, BingCategoryType } from "../../../types";

export const config = { rows: 5, cols: 5 };

export const shuffleTiles = (array: any[]) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

export const setStepCss = (show: boolean, extraCss?: string) =>
  `step${show ? "" : " hide-step"} ${extraCss || ""}`;

const getRandomIndex = (array: any[]) =>
  Math.ceil(Math.random() * (array.length - 1));
const transferRandomTile = (to: any[], from: any[]) => {
  const i = getRandomIndex(from);
  transferTileByIndex(to, from, i);
};
const transferTile = (to: any[], from: any[]) => {
  to.push(from.pop());
};
const transferTileByIndex = (to: any[], from: any[], i: number) => {
  to.push(from.splice(i, 1)[0]);
};

export const selectTilesFromCategories = (
  freeSpace: BingoTileType,
  tilesCategories: BingCategoryType[]
) => {
  let tilesInPlay: BingoTileType[] = [];
  let requiredTiles: BingoTileType[] = [];
  let notRequiredTiles: BingoTileType[] = [];
  const totalTiles = config.rows * config.cols;
  const totalToSelect = totalTiles - 1; // minus freeSpace
  // deep copy
  const availableTiles = [
    ...tilesCategories.map((tile) => ({
      ...tile,
      tiles: tile.tiles.map((t: any) => ({ ...t })),
    })),
  ];

  // Goal here is to add all required tiles to its own array
  // as those get priority selection for the tiles.
  availableTiles.forEach((category, pass) => {
    const { tiles, required } = category;
    const currentRequired: BingoTileType[] = [];
    const currentNotRequired: BingoTileType[] = [];
    // copies a random selection of required tiles, up to the number required,
    // in the required tiles array
    while (tiles.length > 0 && currentRequired.length < required) {
      transferRandomTile(currentRequired, tiles);
    }

    // copies the rest of the tiles to the not required array
    while (tiles.length > 0) {
      transferTile(currentNotRequired, tiles);
    }

    // Add to our final required/not required arrays
    requiredTiles = [...currentRequired, ...requiredTiles];
    notRequiredTiles = [...currentNotRequired, ...notRequiredTiles];
  });

  // Transfer required tiles
  while (tilesInPlay.length < totalToSelect && requiredTiles.length > 0) {
    requiredTiles = shuffleTiles(requiredTiles);
    transferTile(tilesInPlay, requiredTiles);
  }

  // Transfer not required tiles
  while (tilesInPlay.length < totalToSelect && notRequiredTiles.length > 0) {
    notRequiredTiles = shuffleTiles(notRequiredTiles);
    transferTile(tilesInPlay, notRequiredTiles);
  }

  tilesInPlay = shuffleTiles(tilesInPlay); // Shuffle Tiles
  // Add Freespace in the middle
  tilesInPlay.splice(Math.floor(totalTiles / 2), 0, {
    ...freeSpace,
  });
  return tilesInPlay.map((tile, i) => ({ ...tile }));
};

const establishWinParameters = () => {
  const winParameters = {
    cols: {} as any,
    rows: {} as any,
    diag: { "diag-0": [1, 7, 13, 19, 25], "diag-1": [5, 9, 13, 17, 21] },
  };

  let i, j, array;
  for (i = 1; i <= config.cols; i++) {
    // Create win parameter entries for each column
    array = [];
    for (j = 0; j < 5; j++) {
      array.push(i + j * 5);
    }
    winParameters.cols["col-" + (i - 1)] = array;
  }
  for (i = 0; i < config.rows; i++) {
    // Create win parameter entries for each row
    array = [];
    for (j = 1; j <= 5; j++) {
      array.push(i * 5 + j);
    }
    winParameters.rows["row-" + i] = array;
  }

  return winParameters;
};

export const winParameters: any = Object.freeze(establishWinParameters());

export const updateWinLine = (group: string) => {
  if (group === "row-0") {
    return "row-0";
  } else if (group === "row-1") {
    return "row-1";
  } else if (group === "row-2") {
    return "row-2";
  } else if (group === "row-3") {
    return "row-3";
  } else if (group === "row-4") {
    return "row-4";
  } else if (group === "col-0") {
    return "col-b";
  } else if (group === "col-1") {
    return "col-i";
  } else if (group === "col-2") {
    return "col-n";
  } else if (group === "col-3") {
    return "col-g";
  } else if (group === "col-4") {
    return "col-o";
  } else if (group === "diag-0") {
    return "diag-0";
  } else if (group === "diag-1") {
    return "diag-1";
  } else {
    return "";
  }
};

const isPlayingAudio = (ref: React.RefObject<HTMLAudioElement>) => {
  const audio = ref.current;
  return (
    audio &&
    audio.currentTime > 0 &&
    !audio.paused &&
    !audio.ended &&
    audio.readyState > 2
  );
};

export const playAudio = (ref: React.RefObject<HTMLAudioElement>) => {
  stopAudio(ref);
  ref.current?.play();
};
export const stopAudio = (ref: React.RefObject<HTMLAudioElement>) => {
  if (ref.current && isPlayingAudio(ref)) {
    ref.current.pause();
    ref.current.currentTime = 0;
  }
};
